import * as THREE from "three";

export const kowryRendererSettings = {
  outputColorSpace: THREE.SRGBColorSpace,
  toneMapping: THREE.ACESFilmicToneMapping,
  toneMappingExposure: 1.05,
  pixelRatioCap: 2,
  sceneBackground: 0x141719,
} as const;